import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { AdPlacementsGridPreviewPanel } from '@bingads-webui-campaign-react/ad-placements-grid-preview';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getGridPreviewCarouselStyle } from '../../style/js/grid-preview-carousel-style';

export const StyledAdPlacementsGridPreviewPanel = ({
  isOpen,
  onDismiss,
  className,
  cellsNumberPerRow,
  totalCount,
  onRenderCell,
  cellHeight,
}) => {
  const classes = useDefaultStyles(getGridPreviewCarouselStyle);

  const props = {
    isOpen,
    onDismiss,
    cellsNumberPerRow,
    totalCount,
    onRenderCell,
    cellHeight,
  };

  return (
    <div >
      <AdPlacementsGridPreviewPanel
        {...props}
        className={classnames(classes.gridPreviewContainer, className)}
      />
    </div>
  );
};

StyledAdPlacementsGridPreviewPanel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  cellsNumberPerRow: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  onRenderCell: PropTypes.func.isRequired,
  className: PropTypes.string,
  cellHeight: PropTypes.number,
};

StyledAdPlacementsGridPreviewPanel.defaultProps = {
  className: '',
  cellHeight: 482,
};
